// Libraries

// Components
import { Container, Title, Text, Image, Flex, Stack } from '@mantine/core';

// Images
import app_pad_0 from '@/assets/app_pad_0.png'; 
import app_pad_1 from '@/assets/app_pad_1.png';
import app_pad_2 from '@/assets/app_pad_2.png';
import app_pad_3 from '@/assets/app_pad_3.png';
import app_pad_4 from '@/assets/app_pad_4.png';

// Styles
import styles from './Splash.module.css';
import { Link } from 'react-router-dom';

export function Splash() {

    // Render
    return (
        <Container size={'sm'} mt={{ base: '10px', lg: '40px' }}>
            <Stack>

                <Title ff='Josefin Sans Variable' fw='600' pb={10}>TOM HERREN</Title>
                <Text ff='Geist Mono' fz={24} pb={20}>
                I love crafting innovative apps in the financial industry and beyond. 
                </Text>
                
                <Flex maw={{base: '100%'}} h={{base: '390px', xs: '500px', sm: '525px', md: '600px'}}>
                    <div className={styles.animation}>
                        <Image src={app_pad_4} alt='App Pad 4' className={styles.layerFour}/>
                        <Image src={app_pad_3} alt='App Pad 3' className={styles.layerThree}/>
                        <Image src={app_pad_2} alt='App Pad 2' className={styles.layerTwo}/>
                        <Image src={app_pad_1} alt='App Pad 1' className={styles.layerOne}/>
                        <Image src={app_pad_0} alt='App Pad 0' className={styles.base}/>
                    </div>
                </Flex>

            </Stack>


            <Title ff='Josefin Sans Variable' fw='600' pb={10} fz={24}>About Me</Title>
            <Text ff='Geist Mono' fz={16} pb={20}>
    When I'm not leading teams at TD Securities, or coding, you can find me climbing some of the world's tallest peaks or hidden in a good book. I have a passion for designing and building innovative apps that make a difference in the financial industry and beyond. My journey in app development is driven by a love for solving complex problems and creating seamless user experiences. Whether it's through leadership or mountaineering, I am always seeking new challenges and opportunities for growth.
</Text>

            <Title ff='Josefin Sans Variable' fw='600' pb={10} mt={20} fz={24}>Other Things I Enjoy</Title>

            <Link to='/career' className={styles.sectionLink}>
                <Text >Working at TD Securities</Text>
            </Link>
            <Link to='/books' className={styles.sectionLink}>
                <Text >2024 Books I've Read (18/18)</Text>
            </Link>
            {/*<Link to='/blog' className={styles.sectionLink}>
                <Text>Diary of a Director (Blog Coming Soon..)</Text>
            </Link>*/}
            <Link to='/mountains' className={styles.sectionLink}>
                <Text>Mountains</Text>
            </Link>
            <Link to='/projects' className={styles.sectionLink}>
                <Text>Personal Projects</Text>
            </Link>

        </Container>
    );
}

export default Splash;
